import usePageMeta from "@/hooks/usePageMeta";
import { ButtonLink } from "@/components/common/ButtonLink";

export default function NotFound() {
  usePageMeta({ title: "Page not found | SPC", description: "The page you are looking for does not exist." });
  return (
    <section className="flex min-h-[70vh] items-center pt-32" data-testid="not-found">
      <div className="container-x">
        <p className="eyebrow mb-5">404</p>
        <h1 className="h-display">This bridge leads <em className="not-italic text-accent">nowhere</em></h1>
        <ButtonLink to="/" className="mt-10" testId="not-found-home-link">Back to home</ButtonLink>
      </div>
    </section>
  );
}
